<template>
  <div>
    <div style="height: 100%;">

      <form v-if="local_item && local_item.texts">

        <div class="ml-tabs">
          <div class="ml-tabs-header">
            <button
              type="button"
              v-for="(tab, i) in tabs"
              :key="i"
              :class="['ml-tab-button', active_tab === i ? 'active' : '']"
              @click="active_tab = i"
              v-if="!tab.condition || tab.condition"
            >
              {{ $t(tab.label) }}
            </button>
          </div>

          <div class="ml-tabs-body">
            <div v-show="active_tab === 0">
              <m-row>
                <m-col lg="6">
                  <m-row v-if="local_item.id">
                    <m-col>
                      <memlist-text-input
                        
                        id="id"
                        name="id"
                        :title="$t('FORM.ID')"
                        layout="vertical"
                        :disabled="true"
                        v-model="local_item.id"
                        :required="false"
                      >
                      </memlist-text-input>

                    </m-col>
                  </m-row>

                  <m-row class="mt-4">
                    <m-col>

                      <memlist-text-input
                        id="name"
                        name="name"
                        :title="$t('FORM.NAME')"
                        layout="vertical"
                        validation_type="TEXT"

                        v-model="local_item.name"
                        :validate="force_validate"
                        :placeholder="$t('FORM.NAME')"
                        :required="false"
                        :invalid_text="$t('FORM.NAME_REQUIRED')"
                        @validated="validated"
                        @update:value="update_form"
                        >
                      </memlist-text-input>

                    </m-col>
                  </m-row>

                  <m-row class="mt-4">
                    <m-col>
                      
                      <memlist-select-input2
                        id="type"
                        name="type"
                        :title="$t('FORM.TYPE')"
                        layout="vertical"
                        validation_type="TEXT"

                        v-model="local_item.type"
                        :items="type_options"
                        :validate="force_validate"
                        :placeholder="$t('FORM.TYPE')"
                        :required="false"
                        :invalid_text="''"
                        :info_text="''"
                        @validated="validated"
                        @update:value="update_form"
                      />

                    </m-col>
                  </m-row>

                  <m-row class="mt-4" v-if="link_url">
                    <m-col>
                      <p style="font-weight: bold;">{{ $t('FORM.LINK_URL') }}</p>
                      <p><a :href="link_url">{{ link_url }}</a></p>

                    </m-col>
                  </m-row>

                </m-col>
              
                <m-col lg="6">
                  <m-row class="fill-chart">
                     <m-col class="fill-chart">
                      <b>{{ $t('FORM.BAR_VISITORS') }}</b>
                      <div class="chart-wrapper">
                        <FormVisitorBarChart :chart_data="visitor_stats" />
                      </div>
                    </m-col>
                  </m-row>

                  
                  <m-row>
                    <m-col lg="6">
                      <memlist-card class="p-4 mr-4">
                        <b>{{ $t('FORM.TOTAL_VISITS') }}</b>
                        <h1 class="mt-8" style="color: #666666 !important;">{{ stats.first }}</h1>
                      </memlist-card>
                    </m-col>
                    <m-col lg="6">
                      <memlist-card class="p-4 mr-8">
                        <b>{{ $t('FORM.TOTAL_DONE') }}</b>
                        <h1 class="mt-8" style="color: #666666 !important;">{{ stats.done_ok }}</h1>
                      </memlist-card>
                    </m-col>
                  </m-row>
                  
                  
                </m-col>
              </m-row>
            </div>
            <div v-show="active_tab === 1 && local_item.id">
              <FormsPageEditorModal 
                ref="form-page-editor-modal"
                :id="selected_page_id"
                :form="local_item"
                @created="form_page_created"
                @updated="form_page_updated"
              />

              <FormsPageTable 
                :items="local_item.pages"

                @create_form_page_clicked="create_form_page_clicked"
                @delete_form_page_clicked="delete_form_page_clicked"
                @select_form_page_clicked="select_form_page_clicked"
                @move_up_clicked="move_up_clicked"
                @move_down_clicked="move_down_clicked"
              />
            </div>
            <div v-show="active_tab === 2 && local_item.id">
              <FormRuleEditorModal 
                ref="form-rule-editor-modal"
                :item="selected_rule"
                :form="local_item"
                @create="create_form_rule"
                @created="form_rule_created"
                @update="update_form_rule"
              />

              <FormRuleTable 
                :items="local_item.form_rules"

                @create_form_rule_clicked="create_form_rule_clicked"
                @delete_form_rule_clicked="delete_form_rule_clicked"
                @select_form_rule_clicked="select_form_rule_clicked"
              />
            </div>
            <div v-show="active_tab === 3 && local_item.id">
              <FormTermsTab 
                :form="local_item"
              />
            </div>
            <div v-show="active_tab === 4 && local_item.id">
              <m-row class="mt-4">
                <m-col lg="12">

                  <memlist-text-input
                    id="texts_success_header"
                    name="texts_success_header"
                    :title="$t('FORM.TEXTS.SUCCESS_HEADER')"
                    layout="vertical"
                    validation_type="TEXT"

                    v-model="local_item.texts.success_header"
                    :validate="force_validate"
                    :placeholder="$t('FORM.TEXTS.SUCCESS_HEADER')"
                    :required="false"
                    :invalid_text="$t('FORM.REQUIRED_TEXT')"
                    @validated="validated"
                    @update:value="update_form"
                  >
                  </memlist-text-input>

                </m-col>

              </m-row>

              <m-row class="mt-4">

                <m-col lg="12">

                  <memlist-text-input
                    id="texts_success_text"
                    name="texts_success_text"
                    :title="$t('FORM.TEXTS.SUCCESS_TEXT')"
                    layout="vertical"
                    validation_type="TEXT"

                    v-model="local_item.texts.success_text"
                    :validate="force_validate"
                    :placeholder="$t('FORM.TEXTS.SUCCESS_TEXT')"
                    :required="false"
                    :invalid_text="$t('FORM.REQUIRED_TEXT')"
                    @validated="validated"
                    @update:value="update_form"
                  >
                  </memlist-text-input>

                </m-col>

              </m-row>

              <m-row class="mt-4">
                <m-col lg="12">

                  <memlist-text-input
                    id="texts_failure_header"
                    name="texts_failure_header"
                    :title="$t('FORM.TEXTS.FAILURE_HEADER')"
                    layout="vertical"
                    validation_type="TEXT"

                    v-model="local_item.texts.failure_header"
                    :validate="force_validate"
                    :placeholder="$t('FORM.TEXTS.FAILURE_HEADER')"
                    :required="false"
                    :invalid_text="$t('FORM.REQUIRED_TEXT')"
                    @validated="validated"
                    @update:value="update_form"
                  >
                  </memlist-text-input>

                </m-col>

              </m-row>


              <m-row class="mt-4">

                <m-col lg="12">

                  <memlist-text-input
                    id="texts_failure_text"
                    name="texts_failure_text"
                    :title="$t('FORM.TEXTS.FAILURE_TEXT')"
                    layout="vertical"
                    validation_type="TEXT"

                    v-model="local_item.texts.failure_text"
                    :validate="force_validate"
                    :placeholder="$t('FORM.TEXTS.FAILURE_TEXT')"
                    :required="false"
                    :invalid_text="$t('FORM.REQUIRED_TEXT')"
                    @validated="validated"
                    @update:value="update_form"
                  >
                  </memlist-text-input>

                </m-col>

              </m-row>


              <p style="margin-top: 42px;"></p>
            </div>
            
            <div v-show="active_tab === 5 && local_item.id">
              <div class="ml-4" v-if="local_item && local_item.style">
                <m-row class="mt-4">
                  <m-col>
                    <p style="font-weight: 500;">{{ $t('FORM.STYLE.BG') }}</p>
                    <color-picker-input id="field-bg" v-model="local_item.style.bg" class="mr-4 mb-8"/>
                  </m-col>
                  <m-col>
                    <p style="font-weight: 500;">{{ $t('FORM.STYLE.PRIMARY_COLOR') }}</p>
                    <color-picker-input id="field-primary_color" v-model="local_item.style.primary_color" class="mr-4 mb-8"/>
                  </m-col>
                </m-row>
                
                <m-row>
                  <m-col>
                    <p style="font-weight: 500;">{{ $t('FORM.STYLE.HOVER_COLOR') }}</p>
                    <color-picker-input id="field-hover_color" v-model="local_item.style.hover_color" class="mr-4 mb-8"/>
                  </m-col>
                  <m-col>
                    <p style="font-weight: 500;">{{ $t('FORM.STYLE.SECONDARY_COLOR') }}</p>
                    <color-picker-input id="field-secondary_color" v-model="local_item.style.secondary_color" class="mr-4 mb-8"/>
                  </m-col>
                </m-row>
              
              </div>
            </div>

            <div v-show="active_tab === 6 && local_item.id">
              <div v-if="local_item">
                <FormEditorVisitorsTable 
                  :item="local_item"
                />

              </div>
            </div>
          </div>
        </div>

        
        <ErrorPopup
          :error="error_popup_message"
        />

        <m-row>
          <m-col lg="12">
            <RightModalSaveAndCloseButtons
              class="mt-4"
              :text="$t('COMMON.SAVE')"
              :spin="true"
              @clicked="on_save_clicked"
              @close="$emit('cancel')"
              ref="saveButton" />
          </m-col>
        </m-row>
      </form>


    </div>
  </div>
</template>


<script>


import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import { mapGetters } from 'vuex';

import axios from 'axios';
import dayjs from 'dayjs';

import RightModalSaveAndCloseButtons from '@/view/components/buttons/RightModalSaveAndCloseButtons.vue';
import FormsPageTable from '@/view/pages/ml/forms/FormsPageTable.vue';
import FormsPageEditorModal from './FormsPageEditorModal.vue';
import FormVisitorBarChart from './FormVisitorBarChart.vue';
import FormRuleTable from '@/view/pages/ml/forms/rules/FormRuleTable.vue';
import FormRuleEditorModal from '@/view/pages/ml/forms/rules/FormRuleEditorModal.vue';
import FormEditorVisitorsTable from '@/view/pages/ml/forms/FormEditorVisitorsTable.vue';
import FormTermsTab from './FormTermsTab.vue'


import ErrorPopup from '@/view/components/ErrorPopup.vue';
import { get_domain_url, downloadWithAxios } from '@/core/services/fileDownload';
import ColorPickerInput from '@/view/components/ColorPickerInput';


export default {

  name: 'FormEditor',

  props: ['item'],
  emits: ['updated', 'cancel'],
  mixins: [ toasts ],

  components: {
    RightModalSaveAndCloseButtons,
    FormsPageTable,
    FormsPageEditorModal,
    ErrorPopup,
    ColorPickerInput,
    FormVisitorBarChart,
    FormRuleTable,
    FormRuleEditorModal,
    FormEditorVisitorsTable,
    FormTermsTab
  },

  watch: {

    item: {
      deep: true, // check properties of the form, not just the form reference (example.name for example)
      handler(val) {
        let refresh_stats = false;

        if (!this.local_item || this.local_item.id !== this.item.id) {
          refresh_stats = true;
        }

        this.local_item = { ...this.item };

        if (!this.local_item.pages) {
          this.local_item.pages = [];
        }

        if (!this.local_item.style) {
          this.local_item.style = {
            bg: '#ffffff'
          };
        }
        else {
          if (!this.local_item.style.bg) {
            this.local_item.style.bg = '#ffffff';
          }
        }

        if (refresh_stats && this.local_item.id) {
          this.get_stats_for_form(this.local_item.id);
        }
      }
    }
  },


  computed: {
    ...mapGetters(['currentCompanyId', 'currentPeriodId', 'companies']),

    type_options() {
      return [
        { text: this.$t('FORM.TYPES.REGISTER_MEMBER'), value: 'REGISTER_MEMBER' },
        { text: this.$t('FORM.TYPES.RENEW_MEMBER'), value: 'RENEW_MEMBER' },
        { text: this.$t('FORM.TYPES.COMPANY'), value: 'COMPANY' },
        { text: this.$t('FORM.TYPES.EVENT'), value: 'EVENT' },
        { text: this.$t('FORM.TYPES.DONATION'), value: 'DONATION' }
      ]
    },
    link_url() {
      if (this.local_item.id && this.local_item.linkstr.length > 0) {
        return `${get_domain_url()}/form/${this.local_item.linkstr}`;
      }
    }
  },

  async mounted() {

    if (this.item) {
      this.local_item = { ...this.item }
    }

    if (!this.local_item.pages) {
      this.local_item.pages = [];
    }

    if (!this.local_item.style) {
      this.local_item.style = {
        bg: '#ffffff'
      };
    }
    else {
      if (!this.local_item.style.bg) {
        this.local_item.style.bg = '#ffffff';
      }
    }

    this.get_stats_for_form(this.local_item.id);

  },

  methods: {

    
    create_form_rule_clicked() {

      this.selected_rule = {};

      this.$nextTick(()=>{
        this.$refs['form-rule-editor-modal'].show();
      });
    },

    async delete_form_rule_clicked(id) {
      try {
        const response = await axios.delete(`/form/rule/${id}`);

        if (response.status === 204) {
          this.local_item.form_rules = this.local_item.form_rules.filter(p => p.id !== id);

          this.toastr('success', this.$t('COMMON.OK') , this.$t('FORM.FORM_RULE_DELETED'));

          return;
        }
      }
      catch (err) {
        console.error('delete_form_rule_clicked', err);
      }
      },

    async select_form_rule_clicked(id) {

      const res = await axios.get(`/form/rule/${id}`);

      if (res.status === 200) {
        this.selected_rule = res.data;

        console.log('selected_rule', this.selected_rule);

        this.$nextTick(()=>{
          this.$refs['form-rule-editor-modal'].show();
        });
      }
    },

    async get_shop_items_for_companies(company_ids) {
      if (!company_ids || company_ids.length === 0) {
        return [];
      }

      try {
        const res = await axios.post(`/shop_item/list/companies`, company_ids);

        if (res.status === 200) {
          return res.data;
        }
      }
      catch (err) {
        console.error('get_shop_items_for_company', err);
      }

      return [];
    },
    
    async move_down_clicked(id) {
      const res = await axios.put(`/form/page/move/${id}/down`);

      if (res.status === 200) {
        this.local_item.pages = res.data;

        this.local_item = { ...this.local_item };
      }
    },

    async move_up_clicked(id) {
      const res = await axios.put(`/form/page/move/${id}/up`);

      if (res.status === 200) {
        this.local_item.pages = res.data;

        this.local_item = { ...this.local_item };
      }
    },

    form_rule_created(rule) {
      this.local_item.form_rules.push(rule);

      this.local_item = { ...this.local_item };
    },

    async create_form_rule(item) {
      try {
        const response = await axios.post(`/form/${this.local_item.id}/rule`, item);

        if (response.status === 201) {
          this.local_item.form_rules.push(response.data);

          this.local_item = { ...this.local_item };

          this.toastr('success', this.$t('COMMON.OK') , this.$t('FORM.FORM_RULE_CREATED'));

          return;
        }
      }
      catch (err) {
        console.error('create_form_rule', err);
      }
    },

    async update_form_rule(item) {
      try {

        const response = await axios.put(`/form/rule/${item.id}`, item);

        if (response.status === 200) {
          const index = this.local_item.form_rules.findIndex(p => p.id === item.id);

          this.local_item.form_rules[index] = response.data;
          this.local_item.form_rules = [...this.local_item.form_rules];

          this.local_item = { ...this.local_item };

          this.toastr('success', this.$t('COMMON.OK') , this.$t('FORM.FORM_RULE_UPDATED'));

          return;
        }
      }
      catch (err) {
        console.error('update_form_rule', err);
      }
    },

    /// in some cases the child form has created its own page
    form_page_created(page) {
      this.local_item.pages.push(page);

      this.local_item = { ...this.local_item };
    },

    form_page_updated(page) {
      const index = this.local_item.pages.findIndex(i => i.id === page.id);

      if (index < 0) {
        return;
      }

      this.local_item.pages[index] = page;

      this.local_item = { ...this.local_item };
    },
    

    update_form(field_name, value) {

      if (field_name === 'texts_success_header') {
        this.local_item.texts.success_header = value;
      }
      else if (field_name === 'texts_success_text') {
        this.local_item.texts.success_text = value;
      }
      else if (field_name === 'texts_failure_header') {
        this.local_item.texts.failure_header = value;
      }
      else if (field_name === 'texts_failure_text') {
        this.local_item.texts.failure_text = value;
      }
      else {
        this.local_item[field_name] = value;
      }

      console.log('updated field', field_name, value, this.local_item);

      this.local_item = { ...this.local_item };
    },

    validated(field_name, value, valid) {
      this.local_item[field_name] = value;

      if (!valid) {
        this.is_form_valid = false;
      }
    },

    async on_save_clicked() {
      this.spinning = true;
      this.show_error = false;

      this.is_form_valid = true;
      this.force_validate = this.force_validate + 1;

      this.$nextTick(async ()=>{

        try {
          if (this.is_form_valid) {
            this.spinning = false;

            if (this.local_item.id) {
              await this.put_form(this.local_item);  
            }
            else {
              await this.post_form(this.local_item);  
            }
            
          }
          else {
            this.show_error = true; 
          }
        }
        catch (err) {
          console.error('on_save_clicked', err);
        }

        setTimeout(()=>{
          this.spinning = false;

          this.$refs['saveButton'].stop();
        }, 500);
        
      });
    },

    async post_form(item) {
      try {

        item.company_id = this.currentCompanyId;

        const response = await axios.post('/form', item);

        if (response.status === 201) {

          this.local_item = { ...response.data };
          this.local_item.pages = [];

          this.toastr('success', this.$t('COMMON.OK') , this.$t('FORM.CREATED'));

          this.$emit('created', response.data);

          return;
        }
      }
      catch (err) {
        console.error('post_form', err);
      }
    },

    async put_form(item) {
      try {
        const response = await axios.put(`/form/${item.id}`, item);

        if (response.status === 204) {
          this.toastr('success', this.$t('COMMON.OK') , this.$t('FORM.UPDATED'));

          this.$emit('updated', item);

          return;
        }
      }
      catch (err) {
        console.error('put_form', err);
      }
    },

    create_form_page_clicked() {

      this.selected_page_id = null;

      this.$nextTick(()=>{
        this.$refs['form-page-editor-modal'].show();
      });
    },

    async delete_form_page_clicked(id) {
      try {
        const response = await axios.delete(`/form/page/${id}`);

        if (response.status === 204) {
          this.local_item.pages = this.local_item.pages.filter(p => p.id !== id);

          this.toastr('success', this.$t('COMMON.OK') , this.$t('FORM.PAGE_DELETED'));

          return;
        }
      }
      catch (err) {
        console.error('delete_form_page_clicked', err);
      }
    },

    async select_form_page_clicked(id) {
      this.selected_page_id = id;

      this.$nextTick(()=>{
        this.$refs['form-page-editor-modal'].show();
      });

    },

    async get_stats_for_form(form_id) {

      if (!form_id) {
        return;
      }

      try {
        const res1 = await axios.get(`/form/stats/${form_id}/totals?from=${dayjs().subtract(30, 'days').format('YYYY-MM-DD')}&to=${dayjs().format('YYYY-MM-DD')}`);

        this.stats = res1.data;

        const res2 = await axios.get(`/form/stats/${form_id}?from=${dayjs().subtract(30, 'days').format('YYYY-MM-DD')}&to=${dayjs().format('YYYY-MM-DD')}`);

        this.visitor_stats = res2.data;
      }
      catch (err) {
        console.error('get_stats_for_form', err);
      }
    }

  },


  data() {
    return {
      selected_page_id: null,

      active_tab: 0,
      tabs: [
        { label: 'FORM.SETTINGS' },
        { label: 'FORM.PAGES', condition: this.local_item?.id },
        { label: 'FORM.RULES', condition: this.local_item?.id },
        { label: 'FORM.TERMS', condition: this.local_item?.id },
        { label: 'FORM.TEXTS_TAB', condition: this.local_item?.id },
        { label: 'FORM.APPEARANCE', condition: this.local_item?.id },
        { label: 'FORM.VISITORS', condition: this.local_item?.id },
      ],

      selected_rule: {},

      visitor_stats: [],

      stats: {
        first: 0,
        done_error: 0,
        done_ok: 0,
      },

      error_popup_message: null,

      local_item: {
        type: null
      },

      shop_items: [],

      force_validate: 0,
      is_form_valid: false,
      show_error: false,
      spinning: false,
      disabled: false,
      type: 'primary'

    };
  }
};

</script>

<style lang="scss" scoped>

.info-text {
  font-style: italic;
  color: #888888;
}

.chart-wrapper {
  flex: 1;
  display: flex;
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
}

.chart-wrapper > * {
  flex: 1;
}

.fill-chart {
  flex: 1 !important;
  display: flex !important;
  flex-direction: column !important;
  margin: 0 !important;
  padding: 0 !important;
  min-height: 0 !important;
}


</style>
